import { render, staticRenderFns } from "./RefundExchangeAmount.vue?vue&type=template&id=4d242815&"
import script from "./RefundExchangeAmount.vue?vue&type=script&lang=ts&"
export * from "./RefundExchangeAmount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports